/* S16: Share-Link ersetzt das E-Mail-Feld — überschreibt nur openCompletion() und shareFields(). */
(function () {
  try {
    var DE = (document.documentElement.lang || '').toLowerCase().indexOf('de') === 0;
    function T(en, de) { return DE ? de : en; }

    function copyLink() {
      var url = shareURL();
      track('sheet_link_copy', { instrument: state.type });
      function done() { toast(T('Link copied — opens your numbers on any device.', 'Link kopiert — öffnet deine Werte auf jedem Gerät.')); }
      function fallback() {
        try {
          var ta = document.createElement('textarea');
          ta.value = url;
          ta.setAttribute('readonly', '');
          ta.style.cssText = 'position:fixed;top:-1000px;left:-1000px';
          document.body.appendChild(ta);
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
          done();
        } catch (e) {
          window.prompt(T('Copy your link:', 'Deinen Link kopieren:'), url);
        }
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done, fallback);
      } else {
        fallback();
      }
    }

    function bindCopy(root) {
      (root || document).querySelectorAll('.js-copylink').forEach(function (b) {
        if (b.__frtlzrCopy) return;
        b.__frtlzrCopy = 1;
        b.addEventListener('click', copyLink);
      });
    }

    /* Abschluss-Modal: Link statt E-Mail-Feld */
    openCompletion = function () {
      track('setup_complete');
      var html = '<div class="celebrate">'
        + '<div class="tag" style="letter-spacing:.16em;text-transform:uppercase;color:#6b6b6b;font-weight:700;font-size:11px">'
        + T('Setup complete', 'Setup fertig') + '</div>'
        + '<div class="big">Dialed in. Tech it easy.</div>'
        + '<p style="color:#2b2b2b;margin:0 0 14px;font-size:15px">'
        + T('Every step checked. Your numbers stay saved on this device — next time this takes 15 minutes.',
            'Alle Steps abgehakt. Deine Werte bleiben auf diesem Gerät gespeichert — beim nächsten Mal dauert das 15 Minuten.')
        + '</p>'
        + '<p class="hint" style="margin:0 0 14px">'
        + T('Want them on your phone at the bench? Copy your link — it carries every value with it.',
            'Du willst sie am Handy an der Werkbank? Kopier deinen Link — er trägt alle Werte mit sich.')
        + '</p>'
        + '<div class="modal-actions" style="justify-content:center">'
        + '<button class="btnx primary js-copylink">' + T('Copy my link', 'Meinen Link kopieren') + '</button>'
        + '<button class="btnx js-sheet">' + T('Setup sheet', 'Setup-Sheet') + '</button>'
        + '<button class="btnx dark" data-close>' + T('Done', 'Fertig') + '</button>'
        + '</div></div>';
      openModal(html);
      bindCopy(document.getElementById('frtlzr-modalCard'));
    };

    /* Setup-Sheet: Link statt E-Mail-Feld */
    shareFields = function () {
      return '<div class="email-row">'
        + '<button class="btnx primary js-copylink">' + T('Copy link to this sheet', 'Link zu diesem Sheet kopieren') + '</button>'
        + '<button class="btnx js-contribute">' + T('Add to comparison', 'Zum Vergleich beitragen') + '</button>'
        + '</div>'
        + '<p class="hint" style="text-align:left;margin:8px 2px 2px">'
        + T('The link carries your numbers — open it on any device, no account needed. "Add to comparison" shares your numbers anonymously to help other players.',
            'Der Link trägt deine Werte — öffne ihn auf jedem Gerät, ohne Konto. „Zum Vergleich beitragen" teilt deine Werte anonym, um anderen zu helfen.')
        + '</p>'
        + '<button class="btnx js-save-guitar" style="margin-top:10px">' + T('Save to my garage', 'In meiner Garage speichern') + '</button>';
    };

    /* Modal-Inhalte werden per innerHTML ersetzt — nach jedem Oeffnen neu binden */
    var _openModal = openModal;
    openModal = function (html) {
      _openModal(html);
      bindCopy(document.getElementById('frtlzr-modalCard'));
    };
  } catch (e) {
    if (window.console) console.warn('FRTLZR patch S16 failed', e);
  }
})();
